/* Layout adapter only: never reads or writes Wizard's private data/configuration. */
(() => {
  if (window.moebeStickyGalleryLoaded) return;
  window.moebeStickyGalleryLoaded = true;
  const instances = new Map();
  const desktop = window.matchMedia('(min-width: 769px) and (min-height: 480px)');

  function mount(root) {
    if (instances.has(root)) return;
    const column = root.querySelector('.moebe-product-grid > .product-single__sticky');
    if (!column) return;
    const header = document.getElementById('SiteHeader');
    const grid = column.parentElement;
    const details = Array.from(grid.children).find(item => item !== column && item.classList.contains('grid__item'));
    const alignBottom = () => {
      const pairs = root.querySelector('.moebe-pairs');
      const image = Array.from(column.querySelectorAll('.pwzrswiper-slide-active img, .product-main-slide.is-selected img')).find(item => item.getBoundingClientRect().width > 0);
      if (!desktop.matches || !pairs || !image || !image.naturalWidth || !details || details.offsetHeight <= column.offsetHeight) {
        column.style.removeProperty('margin-bottom');
        return;
      }
      const rect = image.getBoundingClientRect();
      const renderedHeight = getComputedStyle(image).objectFit === 'contain' ? Math.min(rect.height, rect.width * image.naturalHeight / image.naturalWidth) : rect.height;
      const imageBottom = rect.bottom - (rect.height - renderedHeight) / 2;
      const tail = column.getBoundingClientRect().bottom - imageBottom;
      const offset = grid.getBoundingClientRect().bottom - pairs.getBoundingClientRect().bottom - tail;
      const value = `${Math.round(offset * 100) / 100}px`;
      if (column.style.marginBottom !== value) column.style.marginBottom = value;
    };
    let frame = 0;
    const set = (key, value) => {
      if (root.style.getPropertyValue(key) !== value) root.style.setProperty(key, value);
    };
    function update() {
      frame = 0;
      if (!desktop.matches) {
        root.style.removeProperty('--moebe-gallery-top');
        root.style.removeProperty('--moebe-gallery-height');
        column.classList.remove('moebe-gallery-too-tall');
        column.style.removeProperty('margin-bottom');
        return;
      }
      // Reserve the sticky header's actual height, including at browser zoom.
      const headerHeight = header?.dataset.sticky === 'true'
        ? header.getBoundingClientRect().height : 0;
      const top = Math.ceil(headerHeight) + 20;
      const viewport = window.visualViewport?.height || window.innerHeight;
      const style = getComputedStyle(column);
      const width = column.clientWidth - parseFloat(style.paddingLeft || 0) - parseFloat(style.paddingRight || 0);
      if (width <= 0) return;
      // Space for pagination and the existing sticky purchase bar at the bottom.
      const available = Math.max(120, viewport - top - 112);
      set('--moebe-gallery-top', `${top}px`);
      set('--moebe-gallery-height', `${Math.floor(Math.min(width, available))}px`);
      // Fail open if an alternative/app-updated gallery cannot fit in the viewport.
      column.classList.toggle('moebe-gallery-too-tall', column.getBoundingClientRect().height > viewport - top - 80);
      alignBottom();
    }
    function schedule() {
      if (!frame) frame = requestAnimationFrame(update);
    }
    const resize = new ResizeObserver(schedule);
    resize.observe(column);
    if (details) resize.observe(details);
    if (header) resize.observe(header);
    // The app inserts its gallery after the native one and replaces slides on variants.
    const mutation = new MutationObserver(schedule);
    mutation.observe(column, {childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'src']});
    root.addEventListener('load', schedule, true);
    window.addEventListener('resize', schedule, {passive: true});
    window.visualViewport?.addEventListener('resize', schedule, {passive: true});
    desktop.addEventListener('change', schedule);
    schedule();
    instances.set(root, () => {
      cancelAnimationFrame(frame);
      resize.disconnect();
      root.removeEventListener('load', schedule, true);
      mutation.disconnect();
      window.removeEventListener('resize', schedule);
      window.visualViewport?.removeEventListener('resize', schedule);
      desktop.removeEventListener('change', schedule);
      instances.delete(root);
    });
  }
  const scan = () => document.querySelectorAll('[data-moebe-sticky-gallery]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, {once: true});
  else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, destroy] of instances) if (event.target.contains(root)) destroy();
  });
})();
